import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _, { object } from 'underscore';
import { makeStyles } from '@material-ui/styles';
import L from 'leaflet';
import {
	Button, Chip, Collapse, Divider, Drawer,
	FormControlLabel, Radio, RadioGroup, Slider,
	TextField, Typography, Checkbox, Card, Grid,
	ListItemText, ListItemIcon, ListItem, ListSubheader,
	List, FormGroup
} from '@material-ui/core';
import { onUpdateLegend } from 'components/Map/actions/MapActions';
import { ToggleButton, ToggleButtonGroup, Autocomplete } from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import validate from 'validate.js';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import ScannerIcon from '@material-ui/icons/Scanner';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import AppsIcon from '@material-ui/icons/Apps';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import {
	SetFormState, GetDriveTestCompare, GetDriveTestScannerCompare,
	GetFailuresPointsVoiceCompare, GetFailuresPointsPacketCompare, GetTopology2gCompare,
	GetTopology3gCompare, GetTopology4gCompare, GetTopology5gCompare, GetDriveTestsTechBandVoiceCompare,
	GetDriveTestsTechBandPacketCompare, GetTopologyLabels2gCompare, GetTopologyLabels3gCompare,
	GetTopologyLabels4gCompare, GetTopologyLabels5gCompare, GetDriveTestScannerCodesCompare, GetScannerRouteCompare
} from '../../actions/FailuresMapActions';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
	// Filter child
	// root: {
	// 	width: '100%',
	// 	maxWidth: 360,
	// 	backgroundColor: theme.palette.background.paper,
	// },
	nested: {
		paddingLeft: theme.spacing(4),
	},
	nestedTwo: {
		paddingLeft: theme.spacing(2),
	},
}));
const bands2g = [];
const bands3g = [];
const bands4g = [];
const bands5g = [];

const FiltersSideCompare = (props) => {
	const { className, onClose, onFilter, filterDisabled, onClear, height, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	// const failures = useSelector(state => state.failuresMapReducer.failures;
	// Map
	const maps = useSelector(state => state.mapReducer.maps);
	const formState = useSelector((state) => state.failuresMapReducer.formState);
	const mapOne = maps.filter(item => item.id === 'failures-map-compare')[0];
	const selectedDates = useSelector((state) => state.failuresMapReducer.selectedDatesCompare);
	const failuresFilters = useSelector(state => state.failuresMapReducer.failuresFiltersSideCompare);
	const failuresVoice = useSelector(state => state.failuresMapReducer.failuresVoiceCompare);
	const failuresPacket = useSelector(state => state.failuresMapReducer.failuresPacketCompare);
	const topology2gData = useSelector(state => state.failuresMapReducer.topology2gDataCompare);
	const topology3gData = useSelector(state => state.failuresMapReducer.topology3gDataCompare);
	const topology4gData = useSelector(state => state.failuresMapReducer.topology4gDataCompare);
	const topology5gData = useSelector(state => state.failuresMapReducer.topology5gDataCompare);
	const topologyLabels2gData = useSelector(state => state.failuresMapReducer.topologyLabels2gDataCompare);
	const topologyLabels3gData = useSelector(state => state.failuresMapReducer.topologyLabels3gDataCompare);
	const topologyLabels4gData = useSelector(state => state.failuresMapReducer.topologyLabels4gDataCompare);
	const topologyLabels5gData = useSelector(state => state.failuresMapReducer.topologyLabels5gDataCompare);
	const techBandVoice = useSelector(state => state.failuresMapReducer.techBandVoiceCompare);
	const techBandPacket = useSelector(state => state.failuresMapReducer.techBandPacketCompare);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const driveTestScannerCodes = useSelector(state => state.failuresMapReducer.driveTestScannerCodesCompare);

	// Topology
	const [openTopology, setOpenTopology] = React.useState(false);
	const [openTopology5g, setOpenTopology5g] = React.useState(false);
	const [openTopology4g, setOpenTopology4g] = React.useState(false);
	const [openTopology3g, setOpenTopology3g] = React.useState(false);
	const [openTopology2g, setOpenTopology2g] = React.useState(false);

	// UE
	const [openUe, setOpenUe] = React.useState(false);
	const [open4g, setOpen4g] = React.useState(false);
	const [open3g, setOpen3g] = React.useState(false);
	const [open2g, setOpen2g] = React.useState(false);
	const [commonMenu, setCommonMenu] = React.useState(false);
	const [openEvents, setOpenEvents] = React.useState(false);
	const [openEventsVoice, setOpenEventsVoice] = React.useState(false);
	const [openEventsPacket, setOpenEventsPacket] = React.useState(false);

	// Scanner
	const [openScanner, setOpenScanner] = React.useState(false);
	const [openScanner4g, setOpenScanner4g] = React.useState(false);
	const [openScanner3g, setOpenScanner3g] = React.useState(false);
	const [openScanner2g, setOpenScanner2g] = React.useState(false);
	const [commonScannerMenu, setCommonScannerMenu] = React.useState(false);

	const [state, setState] = React.useState({
		techBandVoiceSelection: false,
		techBandPacketSelection: false,
		voice: false,
		packet: false,
		topology2g900: false,
		topology2g1800: false,
		topologyLabels2g: false,
		topology3g900: false,
		topology3g2100: false,
		topologyLabels3g: false,
		topology4g800: false,
		topology4g2100: false,
		topology4g2600: false,
		topology5g78: false,
		topologyLabels5g: false,
	});

	const {
		techBandVoiceSelection, techBandPacketSelection,
		voice, packet,
		topology2g900, topology2g1800, topologyLabels2g,
		topology3g900, topology3g2100, topologyLabels3g,
		topology4g800, topology4g2100, topology4g2600, topologyLabels4g,
		topology5g78, topologyLabels5g
	} = state;

	const [value4g, setValue4g] = React.useState('none');
	const [value3g, setValue3g] = React.useState('none');
	const [value2g, setValue2g] = React.useState('none');

	// Scanner
	const [valueScanner4g, setValueScanner4g] = React.useState('none');
	const [valueScanner3g, setValueScanner3g] = React.useState('none');
	const [valueScanner2g, setValueScanner2g] = React.useState('none');

	// Topology
	const handleClickTopology = () => {
		setOpenTopology(!openTopology);
	};
	const handleClickTopology5g = () => {
		setOpenTopology5g(!openTopology5g);
	};
	const handleClickTopology4g = () => {
		setOpenTopology4g(!openTopology4g);
	};
	const handleClickTopology3g = () => {
		setOpenTopology3g(!openTopology3g);
	};
	const handleClickTopology2g = () => {
		setOpenTopology2g(!openTopology2g);
	};

	// UE
	const handleClickUe = () => {
		setOpenUe(!openUe);
	};
	const handleClick4g = () => {
		setOpen4g(!open4g);
	};
	const handleClick3g = () => {
		setOpen3g(!open3g);
	};
	const handleClick2g = () => {
		setOpen2g(!open2g);
	};
	const handleCommonMenu = () => {
		setCommonMenu(!commonMenu);
	};
	const handleClickEvents = () => {
		setOpenEvents(!openEvents);
	};
	const handleClickEventsVoice = () => {
		setOpenEventsVoice(!openEventsVoice);
	};
	const handleClickEventsPacket = () => {
		setOpenEventsPacket(!openEventsPacket);
	};

	// Scanner
	const handleClickScanner = () => {
		setOpenScanner(!openScanner);
	};
	const handleClickScanner4g = () => {
		setOpenScanner4g(!openScanner4g);
	};
	const handleClickScanner3g = () => {
		setOpenScanner3g(!openScanner3g);
	};
	const handleClickScanner2g = () => {
		setOpenScanner2g(!openScanner2g);
	};
	const handleCommonScannerMenu = () => {
		setCommonScannerMenu(!commonScannerMenu);
	};

	const _removeLayerById = (map, id) => {
		map.RemoveLayerById(id);
	};

	const handleChangeType = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		if (event.target.name === 'voice' && event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					voiceActiveCompare: true
				},
			});
			dispatch(
				GetFailuresPointsVoiceCompare(userId, role, formState.values.selectedCity, selectedDates, formState.values.failureTypeVoiceCompare, formState.values.cfn1LevelVoiceCompare)
			);
		} else if (event.target.name === 'voice' && !event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					voiceActiveCompare: false
				},
			});
			_removeLayerById(mapOne.control, 'voice');
		} else if (event.target.name === 'packet' && event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					packetActiveCompare: true
				},
			});
			dispatch(
				GetFailuresPointsPacketCompare(userId, role, formState.values.selectedCity, selectedDates, formState.values.failureTypePacketCompare, formState.values.cfn1LevelPacketCompare)
			);
		} else if (event.target.name === 'packet' && !event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					packetActiveCompare: false
				},
			});
			_removeLayerById(mapOne.control, 'packet');
		}
	};

	const handleChangeTopology2g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		const _map = mapOne.control.mapContext.map;
		const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();

		// console.log(
		// 	`center:${_map.getCenter()}\n`
		// 	+ `width:${width}\n`
		// 	+ `height:${height}\n`
		// 	+ `size in pixels:${_map.getSize()}`
		// );

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology2g900' && event.target.checked) {
			const index = bands2g.indexOf('900');
			if (index === -1) {
				bands2g.push('900');
			}
			dispatch(GetTopology2gCompare(userId, bands2g, mapBoundsPoints));
			if (topologyLabels2g) {
				dispatch(GetTopologyLabels2gCompare(userId, bands2g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology2g900' && !event.target.checked) {
			const index = bands2g.indexOf('900');
			if (index !== -1) {
				bands2g.splice(index, 1);
			}
			dispatch(GetTopology2gCompare(userId, bands2g, mapBoundsPoints));
			dispatch(GetTopologyLabels2gCompare(userId, bands2g, mapBoundsPoints));
		} else if (event.target.name === 'topology2g1800' && event.target.checked) {
			const index = bands2g.indexOf('1800');
			if (index === -1) {
				bands2g.push('1800');
			}
			dispatch(GetTopology2gCompare(userId, bands2g, mapBoundsPoints));
			if (topologyLabels2g) {
				dispatch(GetTopologyLabels2gCompare(userId, bands2g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology2g1800' && !event.target.checked) {
			const index = bands2g.indexOf('1800');
			if (index !== -1) {
				bands2g.splice(index, 1);
			}
			dispatch(GetTopology2gCompare(userId, bands2g, mapBoundsPoints));
			dispatch(GetTopologyLabels2gCompare(userId, bands2g, mapBoundsPoints));
		}
	};

	const handleChangeTopology3g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		const _map = mapOne.control.mapContext.map;
		const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology3g900' && event.target.checked) {
			const index = bands3g.indexOf('900');
			if (index === -1) {
				bands3g.push('900');
			}
			dispatch(GetTopology3gCompare(userId, bands3g, mapBoundsPoints));
			if (topologyLabels3g) {
				dispatch(GetTopologyLabels3gCompare(userId, bands3g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology3g900' && !event.target.checked) {
			const index = bands3g.indexOf('900');
			if (index !== -1) {
				bands3g.splice(index, 1);
			}
			dispatch(GetTopology3gCompare(userId, bands3g, mapBoundsPoints));
			dispatch(GetTopologyLabels3gCompare(userId, bands3g, mapBoundsPoints));
		} else if (event.target.name === 'topology3g2100' && event.target.checked) {
			const index = bands3g.indexOf('2100');
			if (index === -1) {
				bands3g.push('2100');
			}
			dispatch(GetTopology3gCompare(userId, bands3g, mapBoundsPoints));
			if (topologyLabels3g) {
				dispatch(GetTopologyLabels3gCompare(userId, bands3g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology3g2100' && !event.target.checked) {
			const index = bands3g.indexOf('2100');
			if (index !== -1) {
				bands3g.splice(index, 1);
			}
			dispatch(GetTopology3gCompare(userId, bands3g, mapBoundsPoints));
			dispatch(GetTopologyLabels3gCompare(userId, bands3g, mapBoundsPoints));
		}
	};

	const handleChangeTopology4g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });

		const _map = mapOne.control.mapContext.map;
		const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();
		const zoom = _map.getZoom();

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		console.log(mapBounds);
		console.log(zoom);
		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology4g800' && event.target.checked) {
			const index = bands4g.indexOf('800');
			if (index === -1) {
				bands4g.push('800');
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g800' && !event.target.checked) {
			const index = bands4g.indexOf('800');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g2100' && event.target.checked) {
			const index = bands4g.indexOf('2100');
			if (index === -1) {
				bands4g.push('2100');
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g2100' && !event.target.checked) {
			const index = bands4g.indexOf('2100');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topology4g2600' && event.target.checked) {
			const index = bands4g.indexOf('2600');
			if (index === -1) {
				bands4g.push('2600');
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			if (topologyLabels4g) {
				dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology4g2600' && !event.target.checked) {
			const index = bands4g.indexOf('2600');
			if (index !== -1) {
				bands4g.splice(index, 1);
			}
			dispatch(GetTopology4gCompare(userId, bands4g, mapBoundsPoints));
			dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
		}
	};

	const handleChangeTopology5g = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });

		const _map = mapOne.control.mapContext.map;
		const width = _map.getBounds().getEast() - _map.getBounds().getWest();
		const height = _map.getBounds().getNorth() - _map.getBounds().getSouth();
		const zoom = _map.getZoom();

		// Filtro para sql
		const mapBounds = _map.getBounds();
		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		// console.log(mapBounds);
		// console.log(zoom);
		// if (width > 0.65 || height > 0.35) {
		// 	console.log('remover as layers');
		// } else
		if (event.target.name === 'topology5g78' && event.target.checked) {
			const index = bands5g.indexOf('78');
			if (index === -1) {
				bands5g.push('78');
			}
			dispatch(GetTopology5gCompare(userId, bands5g, mapBoundsPoints));
			if (topologyLabels5g) {
				dispatch(GetTopologyLabels5gCompare(userId, bands5g, mapBoundsPoints));
			}
		} else if (event.target.name === 'topology5g78' && !event.target.checked) {
			const index = bands5g.indexOf('78');
			if (index !== -1) {
				bands5g.splice(index, 1);
			}
			dispatch(GetTopology5gCompare(userId, bands5g, mapBoundsPoints));
			dispatch(GetTopologyLabels5gCompare(userId, bands5g, mapBoundsPoints));
		}
	};

	const handleChangeTopologyLabels = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });

		const mapBounds = mapOne.control.mapContext.map.getBounds();

		const mapBoundsPoints = {
			northEast: mapBounds._northEast,
			southWest: mapBounds._southWest
		};

		if (event.target.name === 'topologyLabels2g' && event.target.checked) {
			dispatch(GetTopologyLabels2gCompare(userId, bands2g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels2g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels2g');
		} else if (event.target.name === 'topologyLabels3g' && event.target.checked) {
			dispatch(GetTopologyLabels3gCompare(userId, bands3g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels3g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels3g');
		} else if (event.target.name === 'topologyLabels4g' && event.target.checked) {
			dispatch(GetTopologyLabels4gCompare(userId, bands4g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels4g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels4g');
		} else if (event.target.name === 'topologyLabels5g' && event.target.checked) {
			dispatch(GetTopologyLabels5gCompare(userId, bands5g, mapBoundsPoints));
		} else if (event.target.name === 'topologyLabels5g' && !event.target.checked) {
			_removeLayerById(mapOne.control, 'topologyLabels5g');
		}
	};

	const handleChangeTechBand = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		if (event.target.name === 'techBandVoiceSelection' && event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					techBandVoiceActiveCompare: true
				},
			});
			dispatch(GetDriveTestsTechBandVoiceCompare(formState.values.selectedCity, selectedDates, userId));
		} else if (event.target.name === 'techBandVoiceSelection' && !event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					techBandvoiceActiveCompare: false
				},
			});
			_removeLayerById(mapOne.control, 'techBandVoice');
			if (!formState.values.techBandpacketActiveCompare) {
				dispatch(onUpdateLegend({ id: mapOne.control.mapContext.id, newLegend: '' }));
			}
		} else if (event.target.name === 'techBandPacketSelection' && event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					techBandpacketActiveCompare: true
				},
			});
			dispatch(GetDriveTestsTechBandPacketCompare(formState.values.selectedCity, selectedDates, userId));
		} else if (event.target.name === 'techBandPacketSelection' && !event.target.checked) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					techBandpacketActiveCompare: false
				},
			});
			_removeLayerById(mapOne.control, 'techBandPacket');
			if (!formState.values.techBandvoiceActiveCompare) {
				dispatch(onUpdateLegend({ id: mapOne.control.mapContext.id, newLegend: '' }));
			}
		}
	};

	const handleChangeRoute = (event) => {
		if (event.target.checked && selectedDates.length > 0) {
			setFormState({
				...formState,
				values: {
					...formState.values,
					scannerRouteCompare: true
				},
			});
			dispatch(GetScannerRouteCompare(userId, formState.values.selectedCity, selectedDates));
		} else {
			setFormState({
				...formState,
				values: {
					...formState.values,
					scannerRouteCompare: false
				},
			});
			_removeLayerById(mapOne.control, 'scannerRoute');
		}
	};

	const makeDetailsTable = (item) => {
		const table = `<table class="table table-striped">
							<tr>
							<th>Failure Id: </th>
							<td>${item.failureId}</td>
							</tr>
							<tr>
							<th>Failure Type: </th>
							<td>${item.failureType}</td>
							</tr>
							<tr>
							<th>CFN 1 Level: </th>
							<td>${item.cfn1Level}</td>
							</tr>
							<tr>
							<th>CFN 2 Level: </th>
							<td>${item.cfn2Level}</td>
							</tr>
							<tr>
							<th>CFN 3 Level: </th>
							<td>${item.cfn3Level}</td>
							</tr>
							<tr>
							<th>Latitude: </th>
							<td>${item.latitude}</td>
							</tr>
							<tr>
							<th>Longitude: </th>
							<td>${item.longitude}</td>
							</tr>
						</table>`;
		return table;
	};

	const makeDetailsTableTopology = (item) => {
		const table = `<table class="table table-striped">
						<tr>
						<th>Node Id: </th>
						<td>${item.id}</td>
						</tr>
						<tr>
						<th>Node Name: </th>
						<td>${item.name}</td>
						</tr>
						<tr>
						<th>Latitude: </th>
						<td>${item.latitude}</td>
						</tr>
						<tr>
						<th>Longitude: </th>
						<td>${item.longitude}</td>
						</tr>
					</table>`;
		return table;
	};

	const makeDetailsTechBandKpi = (item) => {
		const table = `<table class="table table-striped">
						<tr>
						<th>Tech: </th>
						<td>${item.tech}</td>
						</tr>
						<tr>
						<th>Band: </th>
						<td>${item.band}</td>
						</tr>
						<tr>
						<th>Latitude: </th>
						<td>${item.latitude}</td>
						</tr>
						<tr>
						<th>Longitude: </th>
						<td>${item.longitude}</td>
						</tr>
					</table>`;

		return table;
	};

	const _addLayerFailures = (map, data, type, fitBounds) => {
		map.RemoveLayerById(type);
		const markers = [];

		const voiceIconBlocked = L.icon({
			iconUrl: '/images/failuresIcons/eventsvoicecallattempt_o2.png',
			iconSize: [35, 35], // size of the icon
			iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
		});

		const voiceIconBlockedQoe = L.icon({
			iconUrl: '/images/failuresIcons/eventsvoiceblockcallQoe_o2.png',
			iconSize: [35, 35], // size of the icon
			iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
		});

		const voiceIconDropped = L.icon({
			iconUrl: '/images/failuresIcons/eventsvoicedropcall_o2.png',
			iconSize: [35, 35], // size of the icon
			iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
		});

		const voiceIconDroppedQoe = L.icon({
			iconUrl: 'images/failuresIcons/eventsvoicedropcallQoe_o2.png',
			iconSize: [35, 35], // size of the icon
			iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
		});

		const packetIcondrop = L.icon({
			iconUrl: 'images/failuresIcons/eventspacketdropcall_o2.png',
			iconSize: [35, 35], // size of the icon
			iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		});

		if (!_.isEmpty(data)) {
			data.forEach(item => {
				if (type.includes('voice')) {
					if (item.failureType === 'Blocked Call') {
						const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconBlocked });
						markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
					} else if (item.failureType === 'QoE Call Setup Time') {
						const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconBlockedQoe });
						markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
					} else if (item.failureType === 'Dropped Call') {
						const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconDropped });
						markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
					} else {
						const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconDroppedQoe });
						markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
					}
				} else {
					const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: packetIcondrop });
					markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
				}
			});

			const layer = L.layerGroup(markers, { id: type });
			layer.addTo(map.mapContext.map);
			const group = new L.featureGroup(markers);
			if (fitBounds) {
				map.mapContext.map.fitBounds(group.getBounds());
			}
		}
	};

	const _addLayerTechBandKpi = (map, data, legend, fitBounds, layerName) => {
		map.RemoveLayerById(layerName);
		const markers = [];

		if (!_.isEmpty(data)) {
			data.forEach(item => {
				const marker = L.circle([item.latitude, item.longitude], {
					color: item.color,
					fillColor: item.color,
					fillOpacity: 0.8,
					radius: 10
				});
				markers.push(marker.bindPopup(`<br>${makeDetailsTechBandKpi(item)}<br>`, { autoPan: false }));
			});

			const layer = L.layerGroup(markers, { id: layerName });
			layer.addTo(map.mapContext.map);
			const group = new L.featureGroup(markers);
			if (fitBounds) {
				map.mapContext.map.fitBounds(group.getBounds());
			}
			dispatch(onUpdateLegend({ id: map.mapContext.id, newLegend: legend }));
		}
	};

	useMemo(() => {
		if (mapOne) {
			_addLayerFailures(mapOne.control, failuresVoice, 'voice', formState.values.mapAutoZoom);
		}
	}, [failuresVoice]);

	useMemo(() => {
		if (mapOne) {
			_addLayerFailures(mapOne.control, failuresPacket, 'packet', formState.values.mapAutoZoom);
		}
	}, [failuresPacket]);

	useMemo(() => {
		if (mapOne) {
			if (topology2gData.length !== 0) {
				mapOne.control.updateTopology2g(topology2gData.topology2gDto, 'topology2g');
			}
		}
	}, [topology2gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels2gData.length !== 0 && topologyLabels2g) {
				mapOne.control.addTopologyLabels(topologyLabels2gData.topologyLabels2gDto, 'topologyLabels2g');
			}
		}
	}, [topologyLabels2gData]);

	useMemo(() => {
		if (mapOne) {
			if (topology3gData.length !== 0) {
				mapOne.control.updateTopology3g(topology3gData.topology3gDto, 'topology3g');
			}
		}
	}, [topology3gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels3gData.length !== 0 && topologyLabels3g) {
				mapOne.control.addTopologyLabels(topologyLabels3gData.topologyLabels3gDto, 'topologyLabels3g');
			}
		}
	}, [topologyLabels3gData]);

	useMemo(() => {
		if (mapOne) {
			if (topology4gData.length !== 0) {
				mapOne.control.updateTopology4g(topology4gData.topology4gDto, 'topology4g');
			}
		}
	}, [topology4gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels4gData.length !== 0 && topologyLabels4g) {
				mapOne.control.addTopologyLabels(topologyLabels4gData.topologyLabels4gDto, 'topologyLabels4g');
			}
		}
	}, [topologyLabels4gData]);

	useMemo(() => {
		if (mapOne) {
			if (topology5gData.length !== 0) {
				mapOne.control.updateTopology5g(topology5gData.topology5gDto, 'topology5g');
			}
		}
	}, [topology5gData]);

	useMemo(() => {
		if (mapOne) {
			if (topologyLabels5gData.length !== 0 && topologyLabels5g) {
				mapOne.control.addTopologyLabels(topologyLabels5gData.topologyLabels5gDto, 'topologyLabels5g');
			}
		}
	}, [topologyLabels5gData]);

	useMemo(() => {
		if (mapOne) {
			_addLayerTechBandKpi(mapOne.control, techBandVoice.driveTestTechBand, techBandVoice.driveTestTechBandLegend, formState.values.mapAutoZoom, 'techBandVoice');
		}
	}, [techBandVoice]);

	useMemo(() => {
		if (mapOne) {
			_addLayerTechBandKpi(mapOne.control, techBandPacket.driveTestTechBand, techBandPacket.driveTestTechBandLegend, formState.values.mapAutoZoom, 'techBandPacket');
		}
	}, [techBandPacket]);

	// UE
	const handleChange4g = (event) => {
		setValue2g('none');
		setValue3g('none');
		setValue4g(event.target.value);
		setValueScanner2g('none');
		setValueScanner3g('none');
		setValueScanner4g('none');
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiTechCompare: '4g',
				selectedKpiScannerTechCompare: undefined
			},
		});
		dispatch(GetDriveTestCompare(userId, '4g', formState.values.selectedCity, selectedDates, event.target.value));
	};

	const handleChange3g = (event) => {
		setValue2g('none');
		setValue3g(event.target.value);
		setValue4g('none');
		setValueScanner2g('none');
		setValueScanner3g('none');
		setValueScanner4g('none');
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiTechCompare: '3g',
				selectedKpiScannerTechCompare: undefined
			},
		});
		dispatch(GetDriveTestCompare(userId, '3g', formState.values.selectedCity, selectedDates, event.target.value));
	};

	const handleChange2g = (event) => {
		setValue2g(event.target.value);
		setValue3g('none');
		setValue4g('none');
		setValueScanner2g('none');
		setValueScanner3g('none');
		setValueScanner4g('none');
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiTechCompare: '2g',
				selectedKpiScannerTechCompare: undefined
			},
		});
		dispatch(GetDriveTestCompare(userId, '2g', formState.values.selectedCity, selectedDates, event.target.value));
	};

	// Scanner
	const handleChangeScanner4g = (event) => {
		setValue2g('none');
		setValue3g('none');
		setValue4g('none');
		setValueScanner2g('none');
		setValueScanner3g('none');
		setValueScanner4g(event.target.value);
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '4g',
				selectedKpiTechCompare: undefined
			},
		});

		dispatch(GetDriveTestScannerCompare(
			userId, '4g', formState.values.selectedCity, selectedDates, event.target.value,
			formState.values.freq4gCompare, formState.values.top4gCompare, formState.values.scannerPciCompare
		));
	};

	const handleChangeScanner3g = (event) => {
		setValue2g('none');
		setValue3g('none');
		setValue4g('none');
		setValueScanner2g('none');
		setValueScanner3g(event.target.value);
		setValueScanner4g('none');
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '3g',
				selectedKpiTechCompare: undefined
			},
		});

		dispatch(GetDriveTestScannerCompare(
			userId, '3g', formState.values.selectedCity, selectedDates, event.target.value,
			formState.values.freq3gCompare, formState.values.top3gCompare, formState.values.scannerScCompare
		));
	};

	const handleChangeScanner2g = (event) => {
		setValue2g('none');
		setValue3g('none');
		setValue4g('none');
		setValueScanner2g(event.target.value);
		setValueScanner3g('none');
		setValueScanner4g('none');
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '2g',
				selectedKpiTechCompare: undefined
			},
		});

		dispatch(GetDriveTestScannerCompare(
			userId, '2g', formState.values.selectedCity, selectedDates, event.target.value,
			formState.values.freq2gCompare, formState.values.top2gCompare, formState.values.scannerBsicCompare
		));
	};

	const _handleChangeFailuresFilters = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value
			},
		});
	};

	const _voiceFilter = useCallback(() => {
		dispatch(
			GetFailuresPointsVoiceCompare(userId, role, formState.values.selectedCity, selectedDates, formState.values.failureTypeVoiceCompare, formState.values.cfn1LevelVoiceCompare)
		);
	}, [formState.values.failureTypeVoiceCompare, formState.values.cfn1LevelVoiceCompare]);

	const _packetFilter = useCallback(() => {
		dispatch(
			GetFailuresPointsPacketCompare(userId, role, formState.values.selectedCity, selectedDates, formState.values.failureTypePacketCompare, formState.values.cfn1LevelPacketCompare)
		);
	}, [formState.values.failureTypePacketCompare, formState.values.cfn1LevelPacketCompare]);

	useEffect(() => {
		if (formState.values.voiceActiveCompare) {
			_voiceFilter();
		}
		if (formState.values.packetActiveCompare) {
			_packetFilter();
		}
	}, [formState.values.failureTypeVoiceCompare, formState.values.cfn1LevelVoiceCompare, formState.values.failureTypePacketCompare, formState.values.cfn1LevelPacketCompare]);

	const cardStyle = {
		height,
		overflow: 'auto'
	};

	const frequencies4g = [
		{ value: '323', text: 323 },
		{ value: '347', text: 347 },
		{ value: '1288', text: 1288 },
		{ value: '2850', text: 2850 },
		{ value: '6300', text: 6300 }
	];

	const frequencies3g = [
		{ value: '2938', text: 2938 },
		{ value: '3012', text: 3012 },
		{ value: '10687', text: 10687 },
		{ value: '10712', text: 10712 }
	];

	const frequencies2g = [
		{ value: '1', text: 1 },
		{ value: '2', text: 2 },
		{ value: '3', text: 3 },
		{ value: '4', text: 4 },
		{ value: '5', text: 5 },
		{ value: '6', text: 6 },
		{ value: '7', text: 7 },
		{ value: '8', text: 8 },
		{ value: '9', text: 9 },
		{ value: '10', text: 10 },
	];

	const topList = [
		{ value: 'all', text: 'All' },
		{ value: '1', text: 1 },
		{ value: '2', text: 2 },
		{ value: '3', text: 3 },
		{ value: '4', text: 4 },
		{ value: '5', text: 5 },
		{ value: '6', text: 6 }
	];

	const _handleChangeFrequency4g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '4g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, event.target.value, formState.values.top4gCompare));

		dispatch(GetDriveTestScannerCompare(
			userId, '4g', formState.values.selectedCity, selectedDates, formState.values.kpi4gScannerCompare,
			event.target.value, formState.values.top4gCompare, formState.values.scannerPciCompare
		));
	};

	const _handleChangeFrequency3g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '3g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, event.target.value, formState.values.top3gCompare));

		dispatch(GetDriveTestScannerCompare(
			userId, '3g', formState.values.selectedCity, selectedDates, formState.values.kpi3gScannerCompare,
			event.target.value, formState.values.top3gCompare, formState.values.scannerScCompare
		));
	};

	const _handleChangeFrequency2g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '2g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, event.target.value, formState.values.top2gCompare));

		dispatch(GetDriveTestScannerCompare(
			userId, '2g', formState.values.selectedCity, selectedDates, formState.values.kpi2gScannerCompare,
			event.target.value, formState.values.top2gCompare, formState.values.scannerBsicCompare
		));
	};

	const _handleChangeTop4g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '4g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, formState.values.freq4gCompare, event.target.value));

		dispatch(GetDriveTestScannerCompare(
			userId, '4g', formState.values.selectedCity, selectedDates, formState.values.kpi4gScannerCompare,
			formState.values.freq4gCompare, event.target.value, formState.values.scannerPciCompare
		));
	};

	const _handleChangeTop3g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '3g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, formState.values.freq3gCompare, event.target.value));

		dispatch(GetDriveTestScannerCompare(
			userId, '3g', formState.values.selectedCity, selectedDates, formState.values.kpi3gScannerCompare,
			formState.values.freq3gCompare, event.target.value, formState.values.scannerScCompare
		));
	};

	const _handleChangeTop2g = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '2g'
			},
		});

		dispatch(GetDriveTestScannerCodesCompare(userId, formState.values.selectedCity, selectedDates, formState.values.freq2gCompare, event.target.value));

		dispatch(GetDriveTestScannerCompare(
			userId, '2g', formState.values.selectedCity, selectedDates, formState.values.kpi2gScannerCompare,
			formState.values.freq2gCompare, event.target.value, formState.values.scannerBsicCompare
		));
	};
	const _handleChangePci = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '4g'
			},
		});
		dispatch(GetDriveTestScannerCompare(
			userId, '4g', formState.values.selectedCity, selectedDates, formState.values.kpi4gScannerCompare,
			formState.values.freq4gCompare, formState.values.top4gCompare, event.target.value
		));
	};

	const _handleChangeSc = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '3g'
			},
		});
		dispatch(GetDriveTestScannerCompare(
			userId, '3g', formState.values.selectedCity, selectedDates, formState.values.kpi3gScannerCompare,
			formState.values.freq3gCompare, formState.values.top3gCompare, event.target.value
		));
	};

	const _handleChangeBsic = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]: event.target.value,
				selectedKpiScannerTechCompare: '2g'
			},
		});
		dispatch(GetDriveTestScannerCompare(
			userId, '2g', formState.values.selectedCity, selectedDates, formState.values.kpi2gScannerCompare,
			formState.values.freq2gCompare, formState.values.top2gCompare, event.target.value
		));
	};

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Typography variant="h5">Layers</Typography>
					<Divider />
					<List
						component="nav"
						aria-labelledby="nested-list-subheader"
						// subheader={(
						// 	<ListSubheader component="div" id="nested-list-subheader">
						// 		Nested List Items
						// 	</ListSubheader>
						// )}
						className={classes.root}
					>
						<ListItem button onClick={handleClickTopology}>
							<ListItemIcon>
								<BubbleChartIcon />
							</ListItemIcon>
							<ListItemText primary="Topology" />
							{openTopology ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={openTopology} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology2g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="2G" />
									{openTopology2g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology2g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology2g900} onChange={handleChangeTopology2g} name="topology2g900" />}
													label="G900"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology2g1800} onChange={handleChangeTopology2g} name="topology2g1800" />}
													label="G1800"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels2g} onChange={handleChangeTopologyLabels} name="topologyLabels2g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology3g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="3G" />
									{openTopology3g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology3g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology3g900} onChange={handleChangeTopology3g} name="topology3g900" />}
													label="U900"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology3g2100} onChange={handleChangeTopology3g} name="topology3g2100" />}
													label="U2100"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels3g} onChange={handleChangeTopologyLabels} name="topologyLabels3g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology4g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="4G" />
									{openTopology4g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology4g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g800} onChange={handleChangeTopology4g} name="topology4g800" />}
													label="L800"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g2100} onChange={handleChangeTopology4g} name="topology4g2100" />}
													label="L2100"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology4g2600} onChange={handleChangeTopology4g} name="topology4g2600" />}
													label="L2600"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels4g} onChange={handleChangeTopologyLabels} name="topologyLabels4g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickTopology5g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="5G" />
									{openTopology5g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openTopology5g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<FormGroup>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topology5g78} onChange={handleChangeTopology5g} name="topology5g78" />}
													label="N78"
												/>
												<FormControlLabel
													className={classes.nestedTwo}
													control={<Checkbox size="small" checked={topologyLabels5g} onChange={handleChangeTopologyLabels} name="topologyLabels5g" />}
													label="Labels"
												/>
											</FormGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
						</Collapse>
						<ListItem button onClick={handleClickUe}>
							<ListItemIcon>
								<PhoneAndroidIcon />
							</ListItemIcon>
							<ListItemText primary="UE" />
							{openUe ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={openUe} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClick2g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="2G" />
									{open2g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={open2g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi2gCompare"
												name="kpi2gCompare"
												value={value2g}
												onChange={handleChange2g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rxLev" control={<Radio size="small" />} label="RxLev" />
												<FormControlLabel value="rxQual" control={<Radio size="small" />} label="RxQual" />
												{/* <FormControlLabel value="bsic" control={<Radio size="small" />} label="BSIC" /> */}
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClick3g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="3G" />
									{open3g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={open3g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi3gCompare"
												name="kpi3gCompare"
												value={value3g}
												onChange={handleChange3g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rscp" control={<Radio size="small" />} label="RSCP" />
												<FormControlLabel value="ecIo" control={<Radio size="small" />} label="Ec/Io" />
												{/* <FormControlLabel value="sc" control={<Radio size="small" />} label="SC" /> */}
												<FormControlLabel value="tpUl" control={<Radio size="small" />} label="TP UL" />
												<FormControlLabel value="tpDl" control={<Radio size="small" />} label="TP DL" />
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClick4g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="4G" />
									{open4g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={open4g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi4gCompare"
												name="kpi4gCompare"
												value={value4g}
												onChange={handleChange4g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rsrp" control={<Radio size="small" />} label="RSRP" />
												<FormControlLabel value="rsrq" control={<Radio size="small" />} label="RSRQ" />
												<FormControlLabel value="sinrVoice" control={<Radio size="small" />} label="SINR Voice" />
												<FormControlLabel value="sinrPacket" control={<Radio size="small" />} label="SINR Packet" />
												<FormControlLabel value="mosSwb" control={<Radio size="small" />} label="MOS SWB" />
												<FormControlLabel value="pciPollution" control={<Radio size="small" />} label="PCI Pollution" />
												<FormControlLabel value="rank" control={<Radio size="small" />} label="Rank" />
												<FormControlLabel value="cqiCw0" control={<Radio size="small" />} label="CQI CW0" />
												<FormControlLabel value="cqiCw1" control={<Radio size="small" />} label="CQI CW1" />
												<FormControlLabel value="bler" control={<Radio size="small" />} label="BLER" />
												<FormControlLabel value="tpUl" control={<Radio size="small" />} label="TP UL" />
												<FormControlLabel value="tpDl" control={<Radio size="small" />} label="TP DL" />
												<FormControlLabel value="tpDlB4M" control={<Radio size="small" />} label="TP DL < 4" />
												<FormControlLabel value="tm" control={<Radio size="small" />} label="TM" />
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleCommonMenu} className={classes.nested}>
									<ListItemIcon>
										<AppsIcon />
									</ListItemIcon>
									<ListItemText primary="Common" />
									{commonMenu ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={commonMenu} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<List component="div" disablePadding>
												<ListItem button onClick={handleClickEvents}>
													{/* <ListItemIcon>
															<BubbleChartIcon />
														</ListItemIcon> */}
													<ListItemText primary="Events" />
													{openEvents ? <ExpandLess /> : <ExpandMore />}
												</ListItem>
												<Collapse in={openEvents} timeout="auto" unmountOnExit>
													<List component="div" disablePadding>
														<ListItem button onClick={handleClickEventsVoice} className={classes.nested}>
															{/* <ListItemIcon>
																	<SettingsInputAntennaIcon />
																</ListItemIcon> */}
															<ListItemText primary="Voice" />
															{openEventsVoice ? <ExpandLess /> : <ExpandMore />}
														</ListItem>
														<Collapse in={openEventsVoice} timeout="auto" unmountOnExit>
															<List component="div" disablePadding>
																<ListItem button>
																	<FormGroup>
																		<FormControlLabel
																			control={<Checkbox checked={voice} onChange={handleChangeType} name="voice" />}
																			label="Show"
																		/>
																	</FormGroup>
																</ListItem>
																<ListItem button>
																	<SelectField
																		id="failureTypeVoiceCompare"
																		name="failureTypeVoiceCompare"
																		hintText="Failure Type"
																		defaultValue=""
																		menuItems={failuresFilters.voice !== undefined ? failuresFilters.voice.failureType : []}
																		onChange={_handleChangeFailuresFilters}
																		value={formState.values.failureTypeVoiceCompare || ''}
																	// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
																	/>
																</ListItem>
																<ListItem button>
																	<SelectField
																		id="cfn1LevelVoiceCompare"
																		name="cfn1LevelVoiceCompare"
																		hintText="CFN 1 Level"
																		defaultValue=""
																		menuItems={failuresFilters.voice !== undefined ? failuresFilters.voice.cfn1Level : []}
																		onChange={_handleChangeFailuresFilters}
																		value={formState.values.cfn1LevelVoiceCompare || ''}
																	// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
																	/>
																</ListItem>
															</List>
														</Collapse>
													</List>
													<List component="div" disablePadding>
														<ListItem button onClick={handleClickEventsPacket} className={classes.nested}>
															{/* <ListItemIcon>
																	<SettingsInputAntennaIcon />
																</ListItemIcon> */}
															<ListItemText primary="Packet" />
															{openEventsPacket ? <ExpandLess /> : <ExpandMore />}
														</ListItem>
														<Collapse in={openEventsPacket} timeout="auto" unmountOnExit>
															<List component="div" disablePadding>
																<ListItem button>
																	<FormGroup>
																		<FormControlLabel
																			control={<Checkbox checked={packet} onChange={handleChangeType} name="packet" />}
																			label="Show"
																		/>
																	</FormGroup>
																</ListItem>
																<ListItem button>
																	<SelectField
																		id="failureTypePacketCompare"
																		name="failureTypePacketCompare"
																		hintText="Failure Type"
																		defaultValue=""
																		menuItems={failuresFilters.packet !== undefined ? failuresFilters.packet.failureType : []}
																		onChange={_handleChangeFailuresFilters}
																		value={formState.values.failureTypePacketCompare || ''}
																	// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
																	/>
																</ListItem>
																<ListItem button>
																	<SelectField
																		id="cfn1LevelPacketCompare"
																		name="cfn1LevelPacketCompare"
																		hintText="CFN 1 Level"
																		defaultValue=""
																		menuItems={failuresFilters.packet !== undefined ? failuresFilters.packet.cfn1Level : []}
																		onChange={_handleChangeFailuresFilters}
																		value={formState.values.cfn1LevelPacketCompare || ''}
																	// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
																	/>
																</ListItem>
															</List>
														</Collapse>
													</List>
												</Collapse>
												<FormGroup>
													<FormControlLabel
														control={(
															<Checkbox
																checked={techBandVoiceSelection}
																onChange={handleChangeTechBand}
																name="techBandVoiceSelection"
															/>
														)}
														label="Tech Band Voice"
													/>
													<FormControlLabel
														control={(
															<Checkbox
																checked={techBandPacketSelection}
																onChange={handleChangeTechBand}
																name="techBandPacketSelection"
															/>
														)}
														label="Tech Band Packet"
													/>
													{/* <FormControlLabel
														control={<Checkbox checked={voice} onChange={handleChangeType} name="voice" />}
														label="Voice Events"
													/>
													<FormControlLabel
														control={<Checkbox checked={packet} onChange={handleChangeType} name="packet" />}
														label="Packet Events"
													/> */}
												</FormGroup>
											</List>
										</ListItem>
									</List>
								</Collapse>
							</List>
						</Collapse>
						{/* </List>
					<List
						component="nav"
						aria-labelledby="nested-list-subheader"
						// subheader={(
						// 	<ListSubheader component="div" id="nested-list-subheader">
						// 		Nested List Items
						// 	</ListSubheader>
						// )}
						className={classes.root}
					> */}
						<ListItem button onClick={handleClickScanner}>
							<ListItemIcon>
								<ScannerIcon />
							</ListItemIcon>
							<ListItemText primary="Scanner" />
							{openScanner ? <ExpandLess /> : <ExpandMore />}
						</ListItem>
						<Collapse in={openScanner} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickScanner2g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="2G" />
									{openScanner2g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openScanner2g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button>
											<SelectField
												id="freq2gCompare"
												name="freq2gCompare"
												hintText="Carrier"
												defaultValue=""
												menuItems={frequencies2g}
												onChange={_handleChangeFrequency2g}
												value={formState.values.freq2gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
											<SelectField
												id="top2gCompare"
												name="top2gCompare"
												hintText="Top"
												defaultValue=""
												menuItems={topList}
												onChange={_handleChangeTop2g}
												value={formState.values.top2gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button>
											<SelectField
												id="scannerBsicCompare"
												name="scannerBsicCompare"
												hintText="BSIC"
												defaultValue=""
												menuItems={(driveTestScannerCodes && driveTestScannerCodes.bsics) || []}
												onChange={_handleChangeBsic}
												value={formState.values.scannerBsicCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi2gScannerCompare"
												name="kpi2gScannerCompare"
												value={valueScanner2g}
												onChange={handleChangeScanner2g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rssiScan" control={<Radio size="small" />} label="RSSI" />
												<FormControlLabel value="bsicScan" control={<Radio size="small" />} label="BSIC" />
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickScanner3g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="3G" />
									{openScanner3g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openScanner3g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button>
											<SelectField
												id="freq3gCompare"
												name="freq3gCompare"
												hintText="Carrier"
												defaultValue=""
												menuItems={frequencies3g}
												onChange={_handleChangeFrequency3g}
												value={formState.values.freq3gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
											<SelectField
												id="top3gCompare"
												name="top3gCompare"
												hintText="Top"
												defaultValue=""
												menuItems={topList}
												onChange={_handleChangeTop3g}
												value={formState.values.top3gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button>
											<SelectField
												id="scannerScCompare"
												name="scannerScCompare"
												hintText="SC"
												defaultValue=""
												menuItems={(driveTestScannerCodes && driveTestScannerCodes.scs) || []}
												onChange={_handleChangeSc}
												value={formState.values.scannerScCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi3gScannerCompare"
												name="kpi3gScannerCompare"
												value={valueScanner3g}
												onChange={handleChangeScanner3g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rscpScan" control={<Radio size="small" />} label="RSCP" />
												<FormControlLabel value="ecioScan" control={<Radio size="small" />} label="Ec/Io" />
												<FormControlLabel value="sirScan" control={<Radio size="small" />} label="SIR" />
												<FormControlLabel value="scScan" control={<Radio size="small" />} label="SC" />
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleClickScanner4g} className={classes.nested}>
									<ListItemIcon>
										<SettingsInputAntennaIcon />
									</ListItemIcon>
									<ListItemText primary="4G" />
									{openScanner4g ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={openScanner4g} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button>
											<SelectField
												id="freq4gCompare"
												name="freq4gCompare"
												hintText="Carrier"
												defaultValue=""
												menuItems={frequencies4g}
												onChange={_handleChangeFrequency4g}
												value={formState.values.freq4gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
											<SelectField
												id="top4gCompare"
												name="top4gCompare"
												hintText="Top"
												defaultValue=""
												menuItems={topList}
												onChange={_handleChangeTop4g}
												value={formState.values.top4gCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button>
											<SelectField
												id="scannerPciCompare"
												name="scannerPciCompare"
												hintText="PCI"
												defaultValue=""
												menuItems={(driveTestScannerCodes && driveTestScannerCodes.pcis) || []}
												onChange={_handleChangePci}
												value={formState.values.scannerPciCompare || ''}
											// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
											/>
										</ListItem>
										<ListItem button className={classes.nested}>
											<RadioGroup
												className={classes.nested}
												aria-label="kpi4gScannerCompare"
												name="kpi4gScannerCompare"
												value={valueScanner4g}
												onChange={handleChangeScanner4g}
											>
												<FormControlLabel value="none" control={<Radio size="small" />} label="None" />
												<FormControlLabel value="rsrpScan" control={<Radio size="small" />} label="RSRP" />
												<FormControlLabel value="rsrqScan" control={<Radio size="small" />} label="RSRQ" />
												<FormControlLabel value="cinrScan" control={<Radio size="small" />} label="CINR" />
												<FormControlLabel value="pciScan" control={<Radio size="small" />} label="PCI" />
											</RadioGroup>
										</ListItem>
									</List>
								</Collapse>
							</List>
							<List component="div" disablePadding>
								<ListItem button onClick={handleCommonScannerMenu} className={classes.nested}>
									<ListItemIcon>
										<AppsIcon />
									</ListItemIcon>
									<ListItemText primary="Common" />
									{commonScannerMenu ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={commonScannerMenu} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										<ListItem button className={classes.nested}>
											<List component="div" disablePadding>
												<FormGroup>
													<FormControlLabel
														control={(
															<Checkbox
																checked={formState.values.scannerRouteCompare}
																onChange={handleChangeRoute}
																name="route"
															/>
														)}
														label="Route"
													/>
												</FormGroup>
											</List>
										</ListItem>
									</List>
								</Collapse>
							</List>
						</Collapse>
					</List>
				</div>
			</div>
		</Card>
	);
};

FiltersSideCompare.propTypes = {
	className: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func,
	height: PropTypes.string
};

export default FiltersSideCompare;
